import React from "react";
import SecondFaq from "../components/secondFaq/SecondFaq";
import Footer from "../components/footer/Footer";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import HirePageSteps from "../components/hire-page-steps/HirePageSteps";
import HireExpertFacts from "../components/hire-expert-facts/HireExpertFacts";
import TrendsInsights from "../components/trends-n-insights/TrendsInsights";
import HireCombinationSection from "../components/hire-combination-sectiono/HireCombinationSection";
import CoverTheStack from "../components/coverthestack/CoverTheStack";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import MegaMenu from "../components/MegaMenu/MegaMenu";
import OurServices from "../components/our-services/OurServices";
import ServicesPageBanner from "../components/services-page-banner/ServicesPageBanner";
import TrustedPartner from "../components/trustedPartners/TrustedPartner";
import NewTestimonials from "../components/new-testimonials/NewTestimonials";
import WhyChooseUs from "../components/why-choose-us/WhyChooseUs";
import NewCaseStudySection from "../components/new-case-study-section/NewCaseStudySection";
import { comapnyCtaContent, hireAndroidDeveloper } from "../data/hireAndroidPageData";
import HirePageTestimonial from "../components/hire-page-testimonial/HirePageTestimonial";
import NewTeamSection from "../components/new-team-section/NewTeamSection";
import WhyChooseBitsclan from "../components/why-choose-bitsclan/WhyChooseBitsclan";
import SimpleModels from "../components/simpleEngagementModels";
import ChallengeSection from "../components/challenge-section/ChallengeSection";
import HirePageSolutionSection from "../components/hire-page-solution-section/HirePageSolutionSection";
import NewCtaSection from "../components/new-cta-section/NewCtaSection";

const HireAndroid = () => {

  return (
    <>
      <Helmet>
        <title>Hire Android Developers | AI & Custom Mobile App Experts at Bitsclan</title>
        <meta name="description" content="Hire expert Android developers and AI/ML engineers at Bitsclan to build future-ready, intelligent mobile apps featuring advanced design, predictive analytics and seamless user experiences. Revolutionize your Android app with AI-powered solutions from a top-rated team fast onboarding, proven results." />
      </Helmet>

      <MegaMenu />

      <ServicesPageBanner
        shortHeading={hireAndroidDeveloper?.mainBanner?.shortHeading}
        mainHeading={hireAndroidDeveloper?.mainBanner?.mainHeading}
        description={hireAndroidDeveloper?.mainBanner?.content}
      />
      <TrustedPartner heading="Trusted & Partnered by Businesses Worldwide to Build High-Performance Android Solutions" />

      <OurServices
        shortHeading={hireAndroidDeveloper?.flutterExpertise?.shortHeading}
        mainHeading={hireAndroidDeveloper?.flutterExpertise?.heading}
        description={hireAndroidDeveloper?.flutterExpertise?.description}
        servicesCardsData={hireAndroidDeveloper?.flutterExpertise?.servicesData}
        buttonText="Start Your ML Project"
      />

      <HirePageTestimonial
        shortHeading="Some of Our Happy Clients"
        mainHeading="Trusted Partnerships. Proven <span>Android Engineering</span> Excellence"
        description="Clients choose our Android developers for their deep expertise in building high-performance, secure, and scalable mobile applications. From concept to deployment, our team ensures smooth collaboration, transparent communication, and results that exceed expectations."
        testimonials={hireAndroidDeveloper?.testimonialsData}
      />

      <NewTeamSection
        shortHeading={"Our Team"}
        mainHeading={"Introducing Our Expert Machine Learning Team"}
        description={"Our specialized Machine Learning engineers expertly handle every stage, from data engineering to model deployment, delivering scalable solutions that drive impactful business results."}
      />

      <NewCtaSection content={hireAndroidDeveloper?.ctaSection} />

      {/* <NewTestimonials
                shortHeading=" Some of Our Happy Clients"
                mainHeading="What Our Clients Say About Bitsclan's <span>Flutter Expertise</span>"
                description="We take pride in our flutter app development services, earning positive feedback from clients who value our dedication, quality, & reliable results. Their satisfaction inspires us to deliver exceptional mobile solutions every time."
            /> */}

      <NewCaseStudySection
        shortHeading="Our Clients Journey"
        heading="Driving Business Success Through Next-Gen Android Development"
        description="Discover how our Android developers help businesses accelerate digital transformation with custom mobile applications that deliver real-world performance, security, and measurable ROI."
      />

      {/* <DevelopmentPerformance
        buttonText={whyChooseUs.btnText}
        heading={whyChooseUs.heading}
        greenHeading={whyChooseUs.greenHeading}
        subHeading={whyChooseUs.subHeading}
        solutions={whyChooseUs.solutionsData}
      /> */}

      <HireCombinationSection
        shortHeading={hireAndroidDeveloper?.techCombinations?.shortHeading}
        combinations={hireAndroidDeveloper?.techCombinations?.combinations}
        heading={hireAndroidDeveloper?.techCombinations?.heading}
        description={hireAndroidDeveloper?.techCombinations?.description}
      />

      <WhyChooseBitsclan
        tabs={hireAndroidDeveloper?.whyChooseBitsclanContet}
        expandAllAccordions={true}
        shortHeading={"How We Work"}
        heading={"Why Leading Companies Trust Us With Their <span>Android Development</span> Teams"}
        subheading={"From UX design to CI/CD deployment, we’ve refined every step of our Android development process to deliver secure, scalable, and high performance applications. <br/> <br/> Our proven methodology ensures 35% faster time-to-market, 40% lower maintenance costs, and enterprise-grade app stability (99.9% uptime) helping you innovate faster while maintaining uncompromised quality."}
        ctaText={"Contact Our Experts"}
      />

      <SimpleModels content={hireAndroidDeveloper?.engagementModels} />

      <CoverTheStack
        shortHeading={hireAndroidDeveloper?.coverTheStack?.shortHeading}
        whereStart={hireAndroidDeveloper?.coverTheStack.whereStart}
        mainHeading={hireAndroidDeveloper?.coverTheStack.mainHeading}
        subHeading={hireAndroidDeveloper?.coverTheStack.subHeading}
        tabs={hireAndroidDeveloper?.coverTheStack.tabs}
        tabItems={hireAndroidDeveloper?.coverTheStack.tabItems}
      />

      <HirePageSteps
        buttonText={hireAndroidDeveloper?.hireSteps.btnText}
        heading={hireAndroidDeveloper?.hireSteps.heading}
        subHeading={hireAndroidDeveloper?.hireSteps.subHeading}
        steps={hireAndroidDeveloper?.hireSteps.steps}
      />

      <ChallengeSection
        mainHeading={"Top Challenges in Android App Development"}
        description={""}
        content={hireAndroidDeveloper?.challengesData}
      />

      <HirePageSolutionSection
        shortHeading="Machine Learning Solutions We Build"
        mainHeading="How We Solve Machine Learning Hiring & Development Challenges"
        description="We simplify the process of hiring, managing, and scaling ML engineering teams. Our approach tackles every challenge from recruitment to deployment ensuring that your projects move seamlessly from concept to production with measurable success."
        content={hireAndroidDeveloper?.mlSolutionsData}
      />

      <WhyChooseUs
        heading={hireAndroidDeveloper?.whyUsContent?.heading}
        greenHeading={hireAndroidDeveloper?.whyUsContent?.greenHeading}
        shortHeading={hireAndroidDeveloper?.whyUsContent?.shortHeading}
        content={hireAndroidDeveloper?.whyUsContent?.content}
        stats={hireAndroidDeveloper?.whyUsContent?.stats}
        cta={hireAndroidDeveloper?.whyUsContent?.cta}
        sectionImage={hireAndroidDeveloper?.whyUsContent?.image}
      />

      {/* <HireExpertFacts
        buttonText={expertFacts.btnText}
        heading={expertFacts.heading}
        greenHeading={expertFacts.greenHeading}
        facts={expertFacts.facts}
        diffBannerBackgroundImage={expertFacts.backgroundImage}
      />

      <HirePageAppIdea
        heading={appIdeaSection?.heading}
        content={appIdeaSection.content}
      /> */}

      {/* <HirePageEngagmentModels
        buttonText={hirePageEngagementModels.btnText}
        heading={hirePageEngagementModels.headingContent}
        content={hirePageEngagementModels.discription}
        hiringDetails={hirePageEngagementModels.hiringDetails}
      /> */}

      {/* <SimpleModels content={engagementModelsContent} /> */}

      <TrendsInsights heading="Only show blogs related to AI/ML" description="Here’s the revised version of the Machine Learning FAQs section, with the word 'hire' replaced and the content focused on business impact" specificClass="mobile-dev-page" category="all" />

      <SecondFaq
        specificClass="mobile-dev-page"
        faqs={hireAndroidDeveloper?.faqSection.faqData}
        mainHeading={hireAndroidDeveloper?.faqSection.mainHeading}
        subHeading={hireAndroidDeveloper?.faqSection.subHeading}
      />

      {/* <ContactSection /> */}

      <SoftwareCompanyCta content={comapnyCtaContent} />

      <Footer />
    </>
  );
};

export default HireAndroid;
